module.exports = __webpack_public_path__ + "img/locker_1.e5ef11a4.png";